import { JobApplicationStatus } from '@qureos/types'

export const DEFAULT_SORT = 'submittedAt'

/* mapping for status against pipeline state values */
export const PipelineStatusMap = {
  invitePending: 'invitePending',
  [JobApplicationStatus.Reviewed]: 'reviewed',
  [JobApplicationStatus.InterviewScheduled]: 'interview',
  [JobApplicationStatus.Shortlisted]: 'shortlisted',
  [JobApplicationStatus.Hired]: 'hired',
  [JobApplicationStatus.Offered]: 'offered',
  [JobApplicationStatus.Excluded]: 'excluded',
  [JobApplicationStatus.Rejected]: 'rejected',
  [JobApplicationStatus.AiInterview]: 'ai_interview'
}

export const PipelineStatusMapName = {
  invitePending: 'invitePending',
  [JobApplicationStatus.Reviewed]: 'review',
  [JobApplicationStatus.InterviewScheduled]: 'interview',
  [JobApplicationStatus.Shortlisted]: 'shortlist',
  [JobApplicationStatus.Hired]: 'hired',
  [JobApplicationStatus.Offered]: 'offered',
  [JobApplicationStatus.Excluded]: 'excluded',
  [JobApplicationStatus.Rejected]: 'excluded',
  [JobApplicationStatus.AiInterview]: 'AI Interview'
}

export const ReverseStageNames = {
  invitePending: 'invitePending',
  [PipelineStatusMapName[JobApplicationStatus.Reviewed]]:
    JobApplicationStatus.Reviewed,
  [PipelineStatusMapName[JobApplicationStatus.InterviewScheduled]]:
    JobApplicationStatus.InterviewScheduled,
  [PipelineStatusMapName[JobApplicationStatus.Shortlisted]]:
    JobApplicationStatus.Shortlisted,
  [PipelineStatusMapName[JobApplicationStatus.Hired]]:
    JobApplicationStatus.Hired,
  [PipelineStatusMapName[JobApplicationStatus.Offered]]:
    JobApplicationStatus.Offered,
  [PipelineStatusMapName[JobApplicationStatus.Excluded]]:
    JobApplicationStatus.Excluded,
  [PipelineStatusMapName[JobApplicationStatus.Rejected]]:
    JobApplicationStatus.Rejected,
  [PipelineStatusMapName[JobApplicationStatus.AiInterview]]:
    JobApplicationStatus.AiInterview
}

export const MovetoStatusMapName = {
  invitePending: 'invitePending',
  review: 'review',
  aiInterview: 'aiInterview',
  interview: 'interview',
  shortlisted: 'shortlist',
  hired: 'hired',
  offered: 'offered',
  excluded: 'excluded',
  rejected: 'rejected'
}

export enum PipelineColumn {
  invitePending = 'Outreach Pending',
  reviewed = 'Screened',
  interview = 'Interview',
  shortlisted = 'Shortlisted',
  offered = 'Offered',
  hired = 'Hired',
  aiInterview = 'AI Interview'
}

export enum CandidateInvitationStatus {
  SCHEDULED = 'scheduled',
  STALED = 'staled',
  PENDING = 'pending',
  SENT = 'sent',
  DISABLED = 'disabled',
  NO_ADDRESS = 'noAddress',
  FAILED = 'failed',
  CANCELED = 'canceled'
}

export const DATE_FIELDS = ['submittedAt', 'appliedAt']

export const REMOVED_STATUSES = [
  JobApplicationStatus.Dropped,
  JobApplicationStatus.Rejected
]

export const cvRatingOptions = [
  {
    label: '1. Invalid file',
    value: 1
  },
  {
    label: '2. Not relevant to the job',
    value: 2
  },
  {
    label: '3. Relevant',
    value: 3
  },
  {
    label: '4. High exp, Relevant',
    value: 4
  },
  {
    label: '5. High exp, Top Company, Relevant',
    value: 5
  }
]

export const submissionRatingOptions = [
  {
    label: '1. Invalid file',
    value: 1
  },
  {
    label: '2. Not relevant',
    value: 2
  },
  {
    label: '3. Well Written',
    value: 3
  },
  {
    label: '4. Well Written, Well Presented',
    value: 4
  },
  {
    label: '5. Very Professional, Well Written, Well Presented',
    value: 5
  }
]

export const REJECTION_REASONS = [
  'Lacking relevant experience',
  'Poor case',
  'Salary and benefits',
  'Unresponsive',
  'Not a culture fit',
  'Other reasons'
]

export const HIRE_NOW = 'Hire Now'
export const BOOK_A_DEMO = 'Book a demo'

export const FOOTER_URLS = {
  HIRING_GUIDE: 'https://www.qureos.com/hiring-guide',
  TOOLS_COMPARISON: 'https://www.qureos.com/tools-comparison',
  INTERVIEW_QUESTIONS_GENERATOR:
    'https://app.qureos.com/interview-questions-generator',
  JOB_DESCRIPTION_GENERATOR: 'https://app.qureos.com/job-description-generator',
  CAREER_GUIDE: 'https://www.qureos.com/career-guide',
  EXPLORE_JOBS: 'https://app.qureos.com/jobs',
  PROJECTS: 'https://www.qureos.com/project',
  COMMUNITY_EVENTS: 'https://www.qureos.com/learning-hub',
  ONE_ON_ONE_MENTORSHIP: 'https://www.qureos.com/mentorship',
  RESOURCES: 'https://resources.qureos.com/',
  SALARY_CALCULATOR: 'https://tools.qureos.com/salary-calculator/',
  QUREOS_SUPPORT: 'mailto:hello@qureos.com?subject=Hey Qureos!',
  ABOUT: 'https://www.qureos.com/about',
  SUBMIT_GUEST_BLOGS: 'https://www.qureos.com/guest-post-guidelines',
  FACEBOOK: 'https://www.facebook.com/qureos',
  INSTAGRAM: 'https://www.instagram.com/bequreos/',
  LINKEDIN: 'https://www.linkedin.com/company/qureos',
  TWITTER: 'https://twitter.com/bequreos',
  YOUTUBE: 'https://www.youtube.com/c/Qureos',
  TIKTOK: 'https://www.tiktok.com/@learnqureos',
  DISCORD: 'https://discord.com/invite/MWFdJzMJCD',
  TERM_OF_USE: 'https://www.qureos.com/terms-of-use',
  PRIVACY_POLICY: 'https://www.qureos.com/privacy-policy'
}
